import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { updateAccountLinkStartAt } from '../api'

interface UseUpdateAccountLinkStartAtParams {
  onSuccess?: (vars: UpdateAccountLinkStartAtVariables) => void
  onError?: (error: unknown, vars: UpdateAccountLinkStartAtVariables) => void
}

interface UpdateAccountLinkStartAtVariables {
  installationId: number
  accountLinkId: number
  startAt: string
  reason: string
}

type UseUpdateAccountLinkStartAtReturnType = (
  data: UseUpdateAccountLinkStartAtParams
) => UseMutationResult<void | null, unknown, UpdateAccountLinkStartAtVariables>

/**
 * Hook to update the startAt date of an account link
 */
export const useUpdateAccountLinkStartAt: UseUpdateAccountLinkStartAtReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation({
    mutationFn: ({ installationId, accountLinkId, startAt, reason }) =>
      updateAccountLinkStartAt({ authFetch, installationId, accountLinkId, startAt, reason }),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (error, vars) => onError?.(error, vars),
  })
}
